import { IRetailerRestrictionsResponse } from "@faire/web-api/indigofair/data/IRetailerRestrictionsResponse";
import React, { Dispatch, SetStateAction, useContext } from "react";

export interface IBrandPageStateContext {
  brandToken: string;
  hasFaireProtection: boolean;
  setHasFaireProtection: Dispatch<SetStateAction<boolean>>;
  isFaireProtectionModalClosed: boolean;
  setIsFaireProtectionModalClosed: Dispatch<SetStateAction<boolean>>;
  isFavoriteBrand: boolean;
  setIsFavoriteBrand: Dispatch<SetStateAction<boolean>>;
  retailerRestrictions?: IRetailerRestrictionsResponse;
}

const DEFAULT_BRAND_PAGE_STATE: IBrandPageStateContext = {
  brandToken: "",
  hasFaireProtection: false,
  setHasFaireProtection: () => {},
  isFaireProtectionModalClosed: false,
  setIsFaireProtectionModalClosed: () => {},
  isFavoriteBrand: false,
  setIsFavoriteBrand: () => {},
  retailerRestrictions: undefined,
};

export const BrandPageStateContext =
  React.createContext<IBrandPageStateContext>(DEFAULT_BRAND_PAGE_STATE);

export const useBrandPageStateContext = () => {
  const value = useContext(BrandPageStateContext);

  if (value === DEFAULT_BRAND_PAGE_STATE) {
    throw new Error(
      "useBrandPageStateContext must be used within a BrandPageStateContext.Provider"
    );
  }
  return value;
};
